import React, { useEffect, useState } from "react";
import { InputTypeDropdown } from "../../../elements";
import Axios from "axios";
import { API_URL } from "../../../../lib/const";


type TransferApplicationGradeInputProps = {
  label: string,
  field: string,
  col?: string,
  exclude?: number,
  disabled?: boolean,
  processId?: number,
  className?: string,
}

const TransferApplicationGradeInput = ({ processId, label, field, className, exclude, col = "12", disabled = false }: TransferApplicationGradeInputProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [options, setOptions] = useState<{ id: number, field_step: number }[]>([]);

  useEffect(() => {
    if (processId) {
      setLoading(true);

      Axios.get(`${API_URL}/transfers/processes/${processId}/avaiable_grades`)
        .then(response => {
          setLoading(false);
          setOptions(response.data);
        })
    }
  }, [processId])

  return (
    <InputTypeDropdown
      className={className}
      disabled={disabled || (!!!processId || loading)}
      options={options.filter(o => o.id !== exclude).map((o) => ({ value: o.id, label: o.field_step }))}
      field={field}
      helper={(() => {
        if (!!!processId) {
          return 'Selecione o processo para listar os períodos'
        }

        if (loading) {
          return 'Carregando, por favor aguarde'
        }

      })()}
      label={label}
      col={col}
      required
    />
  )
}

export default TransferApplicationGradeInput;
